// extracted by mini-css-extract-plugin
export default {"statusBadge":"TicketStatusBadge_statusBadge__IZDVe"};